import React from "react";
import { Link } from "react-router-dom";
import { globalAppInfo } from "../../config/globalAppInfo";
import "../../pages/landing/LandingPageNew.css";

const FooterBar = ({ theme }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-new">
      <div className="landing-container">
        <div className="footer-grid">
          <div className="footer-brand">
            <img
              src={
                theme === "light"
                  ? "/horizontal-transparent-light.png"
                  : "/horizontal-transparent-dark.png"
              }
              alt="MessageOS"
            />
            <p>
              The complete WhatsApp Business API platform for customer engagement,
              marketing automation, and team collaboration.
            </p>
            {/* Social icons shown inside brand block on mobile */}
            <div className="footer-social footer-social--brand">
              <span className="footer-social-icon footer-social-icon--disabled footer-social-icon--twitter" aria-label="Twitter">𝕏</span>
              <span className="footer-social-icon footer-social-icon--disabled footer-social-icon--facebook" aria-label="Facebook">f</span>
              <span className="footer-social-icon footer-social-icon--disabled footer-social-icon--linkedin" aria-label="LinkedIn">in</span>
              <span className="footer-social-icon footer-social-icon--disabled footer-social-icon--instagram" aria-label="Instagram">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                  <circle cx="12" cy="12" r="4"/>
                  <circle cx="17.5" cy="6.5" r="0.5" fill="currentColor" stroke="none"/>
                </svg>
              </span>
            </div>
          </div>

          <div className="footer-column">
            <h4>Product</h4>
            <ul>
              <li><a href="#features">Features</a></li>
              <li><a href="#pricing">Pricing</a></li>
              <li><a href="#demo">Demo</a></li>
              <li><Link to="/api-docs">API Documentation</Link></li>
              <li><Link to="/login">Login</Link></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>Company</h4>
            <ul>
              <li><a href="#hero">About Us</a></li>
              <li><a href="#testimonials">Testimonials</a></li>
              <li><a href="mailto:support@messageos.com">Contact</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>Legal</h4>
            <ul>
              <li><Link to="/terms-of-service">Terms of Service</Link></li>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/refund-policy">Refund Policy</Link></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-copyright">
            © {currentYear} {globalAppInfo.name}. All Rights Reserved.
          </div>
          {/* Social icons shown in bottom bar on desktop only */}
          <div className="footer-social footer-social--bottom">
            <span className="footer-social-icon footer-social-icon--disabled footer-social-icon--twitter" aria-label="Twitter">𝕏</span>
            <span className="footer-social-icon footer-social-icon--disabled footer-social-icon--facebook" aria-label="Facebook">f</span>
            <span className="footer-social-icon footer-social-icon--disabled footer-social-icon--linkedin" aria-label="LinkedIn">in</span>
            <span className="footer-social-icon footer-social-icon--disabled footer-social-icon--instagram" aria-label="Instagram">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                <circle cx="12" cy="12" r="4"/>
                <circle cx="17.5" cy="6.5" r="0.5" fill="currentColor" stroke="none"/>
              </svg>
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterBar;
